import HttpRequest from "./http_request";

class ConfigProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_API_URL);
  }

  //===========================================================================
  //ConfigAcademic
  async getAcademics() {
    const { data } = await this.get("/", {
      function: "get-config",
      table: "REGISTRATION_DATE_TIME",
      order: [
        {
          YEAR: "DESC",
          SEMESTER: "DESC",
        },
      ],
    });
    return data;
  }
  async setAcademics({
    level_id,
    sub_level_id,
    year,
    semester,
    start_system_date,
    start_academic_date,
    end_academic_date,
    start_teach_table_date,
    end_teach_table_date,
    start_midterm_date,
    end_midterm_date,
    start_final_date,
    end_final_date,
    start_pre_regis_date,
    end_pre_regis_date,
    start_regis_date,
    end_regis_date,
    start_add_change_date,
    end_add_change_date,
    start_withdraw_date,
    end_withdraw_date,
  }) {
    const { data } = await this.create("/", {
      function: "set-academic-date-time",
      LEVEL_ID: level_id,
      SUB_LEVEL_ID: sub_level_id,
      YEAR: year,
      SEMESTER: semester,
      START_DATETIME_SYSTEM: start_system_date,
      START_DATETIME_ACADEMIC: start_academic_date,
      END_DATETIME_ACADEMIC: end_academic_date,
      START_DATETIME_CONFIG_TEACH_TABLE: start_teach_table_date,
      END_DATETIME_CONFIG_TEACH_TABLE: end_teach_table_date,
      START_DATETIME_MIDTERM: start_midterm_date,
      END_DATETIME_MIDTERM: end_midterm_date,
      START_DATETIME_FINAL: start_final_date,
      END_DATETIME_FINAL: end_final_date,
      START_DATETIME_PRE_REGIS: start_pre_regis_date,
      END_DATETIME_PRE_REGIS: end_pre_regis_date,
      START_DATETIME_REGIS: start_regis_date,
      END_DATETIME_REGIS: end_regis_date,
      START_DATETIME_ADD_CHANGE: start_add_change_date,
      END_DATETIME_ADD_CHANGE: end_add_change_date,
      START_DATETIME_WITHDRAW: start_withdraw_date,
      END_DATETIME_WITHDRAW: end_withdraw_date,
    });
    return data;
  }
  async deleteAcademics({ id }) {
    const { data } = await this.delete("/", {
      function: "delete-config",
      table: "REGISTRATION_DATE_TIME",
      where: {
        ID: id,
      },
    });
    return data;
  }
  //ConfigPayment
  async getPayments() {
    const { data } = await this.get("/", {
      function: "get-config",
      table: "REGISTRATION_PAYMENT",
      order: [
        {
          YEAR: "DESC",
          SEMESTER: "DESC",
        },
      ],
    });
    return data;
  }
  async setPayments({
    level_id,
    year,
    semester,
    start_datetime_no_charge,
    end_datetime_no_charge,
    start_datetime_regist_charge,
    end_datetime_regist_charge,
    regist_charge,
    start_datetime_pay_late_charge,
    end_datetime_pay_late_charge,
    pay_late_charge_per_day,
    last_datetime_pay_date,
  }) {
    const { data } = await this.create("/", {
      function: "set-payment-date-time",
      LEVEL_ID: level_id,
      YEAR: year,
      SEMESTER: semester,
      START_DATETIME_NO_CHARGE: start_datetime_no_charge,
      END_DATETIME_NO_CHARGE: end_datetime_no_charge,
      START_DATETIME_REGIST_CHARGE: start_datetime_regist_charge,
      END_DATETIME_REGIST_CHARGE: end_datetime_regist_charge,
      REGIST_CHARGE: regist_charge,
      START_DATETIME_PAY_LATE_CHARGE: start_datetime_pay_late_charge,
      END_DATETIME_PAY_LATE_CHARGE: end_datetime_pay_late_charge,
      PAY_LATE_CHARGE_PER_DAY: pay_late_charge_per_day,
      LAST_DATETIME_PAY_DATE: last_datetime_pay_date,
    });
    return data;
  }
  async deletePayments({ id }) {
    const { data } = await this.delete("/", {
      function: "delete-config",
      table: "REGISTRATION_PAYMENT",
      where: {
        ID: id,
      },
    });
    return data;
  }

  // ดึงข้อมูลรายชื่อไปฝึก/เรียนที่สิรินธร
  async getMedicineSirindhornStudent({ year, semester }) {
    const { data } = await this.get("/", {
      function: "get-medicine-sirindhorn-student",
      year,
      semester,
    });
    return data;
  }

  // เพิ่มรายชื่อไปฝึก/เรียนที่สิรินธร
  async setMedicineSirindhornStudent({ year, semester, student_id }) {
    const { data } = await this.create("/", {
      function: "set-medicine-sirindhorn-student",
      year,
      semester,
      student_id,
    });
    return data;
  }

  // ลบรายชื่อไปฝึก/เรียนที่สิรินธร
  async deleteMedicineSirindhornStudent({ year, semester, student_id }) {
    const { data } = await this.delete("/", {
      function: "delete-medicine-sirindhorn-student",
      year,
      semester,
      student_id,
    });
    return data;
  }

  // รายการตั้งค่าค่าธรรมเนียมการศึกษารายบุคคล
  async getIndividualTuitionFee({ level, year, semester, student_id, type_fee}) {
    const { data } = await this.get("/", {
      function: "get-individual-tuition-fee",
      level,
      year,
      semester,
      student_id,
      type_fee
    });
    return data;
  }

  // เพิ่มค่าธรรมเนียมการศึกษารายบุคคล
  async setIndividualTuitionFee({
    year,
    semester,
    level,
    student_id,
    tuition_fee,
    subsidy_fee,
    remark,
  }) {
    const { data } = await this.create("/", {
      function: "set-individual-tuition-fee",
      year,
      semester,
      level,
      student_id,
      tuition_fee,
      subsidy_fee,
      remark,
    });
    return data;
  }

  // ลบค่าธรรมเนียมการศึกษารายบุคคล
  async deleteIndividualTuitionFee({ year, semester, level, student_id }) {
    const { data } = await this.delete("/", {
      function: "delete-individual-tuition-fee",
      year,
      semester,
      level,
      student_id,
    });
    return data;
  }

  // รายการตั้งค่าหน่วยกิตวิชาวิทยานิพนธ์
  async getGraduateSeparateThesisCredit({ curr_id, year, semester }) {
    const { data } = await this.get("/", {
      function: "get-graduate-separate-thesis-credit",
      curr_id,
      year,
      semester,
    });
    return data;
  }

  // เพิ่มหรือแก้ไขการตั้งค่าหน่วยกิตวิชาวิทยานิพนธ์
  async setGraduateSeparateThesisCredit({
    faculty_id,
    curr_id,
    admis_year,
    admis_term,
    prog_id,
    sub_prog_id,
    subject_id,
    credit_all,
    term1,
    term2,
    term3,
    term4,
    term5,
    term6,
    term7,
    term8,
    term9,
    term10,
  }) {
    const { data } = await this.create("/", {
      function: "set-graduate-separate-thesis-credit",
      faculty_id,
      curr_id,
      admis_year,
      admis_term,
      prog_id,
      sub_prog_id,
      subject_id,
      credit_all,
      term1,
      term2,
      term3,
      term4,
      term5,
      term6,
      term7,
      term8,
      term9,
      term10,
    });
    return data;
  }

  // ลบการตั้งค่าหน่วยกิตวิชาวิทยานิพนธ์
  async deleteGraduateSeparateThesisCredit({
    faculty_id,
    curr_id,
    admis_year,
    admis_term,
    prog_id,
    sub_prog_id,
    subject_id,
  }) {
    const { data } = await this.delete("/", {
      function: "delete-graduate-separate-thesis-credit",
      faculty_id,
      curr_id,
      admis_year,
      admis_term,
      prog_id,
      sub_prog_id,
      subject_id,
    });
    return data;
  }

  // รายการตั้งค่าค่าธรรมเนียมการศึกษาแต่ละหลักสูตร ระดับบัณฑิตศึกษา
  async getGraduateCurriculumFee({
    curr_id,
    admis_year,
    admis_term,
  }) {
    const { data } = await this.get("/", {
      function: "get-graduate-curriculum-fee",
      curr_id,
      admis_year,
      admis_term,
    });
    return data;
  }

  // เพิ่มหรือแก้ไขการตั้งค่าค่าธรรมเนียมการศึกษาแต่ละหลักสูตร ระดับบัณฑิตศึกษา
  async setGraduateCurriculumFee({
    faculty_id,
    curr_id,
    admis_type,
    admis_year,
    admis_term,
    inter_student,
    prog_id,
    package_fee,
    maintain_fee,
    leave_fee,
    summer_fee,
  }) {
    const { data } = await this.create("/", {
      function: "set-graduate-curriculum-fee",
      faculty_id,
      curr_id,
      admis_type,
      admis_year,
      admis_term,
      inter_student,
      prog_id,
      package_fee,
      maintain_fee,
      leave_fee,
      summer_fee,
    });
    return data;
  }

  // ลบการตั้งค่าค่าธรรมเนียมการศึกษาแต่ละหลักสูตร ระดับบัณฑิตศึกษา
  async deleteGraduateCurriculumFee({
    faculty_id,
    curr_id,
    admis_type,
    admis_year,
    admis_term,
    inter_student,
    prog_id,
  }) {
    const { data } = await this.delete("/", {
      function: "delete-graduate-curriculum-fee",
      faculty_id,
      curr_id,
      admis_type,
      admis_year,
      admis_term,
      inter_student,
      prog_id,
    });
    return data;
  }
}
export default ConfigProvider;
